import { mergeMap } from 'rxjs/operators'
import { ofType, StateObservable } from 'redux-observable'
import * as actions from '../../actions'
import { State } from '../../reducers/reducerType'
import { SET_ROLE } from '../../constants/actionTypes'

const errorLogger$ = (actions$, state$: StateObservable<State>) => actions$.pipe(
  ofType(SET_ROLE),
  mergeMap(() => { 
    return [actions.setErrorLogger()]
  }
  )
)

export default errorLogger$
